export const filter = state => state.searchFilter;
export const results = state => state.searchResults;
export const count = state => state.resultCount;



// WEBPACK FOOTER //
// ./src/screens/Search/store/getters.js